<forge-backdrop [visible]="overlay || page" id="spinnerOverlay" [ngClass]="spinnerOverLayClasses" [attr.fixed]="dialog ? 'true' : null">
</forge-backdrop>

@if (!chart && !card && page) {
  <div [ngClass]="progressSpinnerClasses" #busyIndicatorCard class="page" fxLayout="column" fxLayoutAlign="center center">
    <forge-card>
      <div fxLayout="column" fxLayoutAlign="center center">
        <forge-circular-progress>
        </forge-circular-progress>
        @if (message) {
          <span class="forge-typography--body2 busy-message">{{message}}</span>
        }
      </div>
    </forge-card>
  </div>
}

@if (!chart && !card && !page) {
  <forge-circular-progress class="basic">
  </forge-circular-progress>
}

@if (chart) {
  <div fxLayout="column" fxLayoutAlign="space-between center" class="chart">
    <div fxLayout="row" fxLayoutAlign="space-between end">
      <div>
        <forge-skeleton class="h180p" text></forge-skeleton>
      </div>
      <div>
        <forge-skeleton class="h270p" text></forge-skeleton>
      </div>
      <div>
        <forge-skeleton class="h140p" text></forge-skeleton>
      </div>
      <div>
        <forge-skeleton class="h210p" text></forge-skeleton>
      </div>
      <div>
        <forge-skeleton class="h290p" text></forge-skeleton>
      </div>
      <div>
        <forge-skeleton class="h220p" text></forge-skeleton>
      </div>
      <div>
        <forge-skeleton class="h160p" text></forge-skeleton>
      </div>
    </div>
  </div>
}

@if (card) {
  <forge-card class="card">
    <forge-skeleton form-field></forge-skeleton>
    <forge-skeleton form-field></forge-skeleton>
    <forge-skeleton form-field></forge-skeleton>
  </forge-card>
}
